export const parseWithExpectedVersion: <T>(stateJson: string | undefined | null, expectedVersion: number) => T | undefined = (stateJson, expectedVersion) => {
  if (stateJson != null) {
    const state = JSON.parse(stateJson);
    if (state?.version === expectedVersion) return state;
  }
  return undefined;
};
